import React, { useEffect, useState } from 'react';
import { SxStyle } from '../../../types';
import { convertFirestoreLogToDatagridFormat } from './utils/data';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import svStrings from '../../../sv-strings';
import firebaseApp from '../../../firebase-app';
import Paper from '@mui/material/Paper';
import { collection, getDocs, query, limit, orderBy } from 'firebase/firestore';
import SelectType from './components/select-type';
import { PushNotificationType, PushNotificationLog } from './types';
import Stack from '@mui/material/Stack';
import { useRouteMatch } from 'react-router-dom';

const columns: GridColDef[] = [
  { field: 'timestamp', headerName: svStrings.pushNotifications.fieldNameDate, width: 160 },
  { field: 'title', headerName: svStrings.pushNotifications.fieldNameTitle, width: 400 },
  { field: 'message', headerName: svStrings.pushNotifications.fieldNameMessage, width: 400 },
];

const styles: SxStyle = {
  container: (theme) => ({
    width: '100%',
    height: 'calc(100% - 60px)',
    marginTop: theme.spacing(4),
  }),
  dataGrid: (theme) => ({
    '& .MuiDataGrid-root .MuiDataGrid-cell:focus, .MuiDataGrid-cell:focus-within': {
      outline: 'none',
    },
    '& .MuiDataGrid-columnHeader:focus, .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none',
    },
    '& .MuiDataGrid-columnHeaderTitleContainer, .MuiDataGrid-columnHeaderTitleContainerContent': {
      width: '100%',
    },
    '& .MuiDataGrid-row:nth-of-type(odd)': {
      backgroundColor: theme.palette.shades.p10,
    },
  }),
};

const PushNoticationAutomated = () => {
  const { params } = useRouteMatch<{ abbrv?: string }>();
  const selectedAbbrv = params.abbrv || null;
  const [selectedType, setSelectedType] = useState<PushNotificationType>('scheduled');
  const [notificationDocs, setNotificationDocs] = useState<PushNotificationLog[] | null>(null);

  useEffect(() => {
    if (selectedAbbrv) {
      const getNotificationDocs = async () => {
        const colRef = collection(
          firebaseApp.db,
          `/log-v3/firebase-triggers/triggers/${selectedType}/notifications/${selectedAbbrv.toUpperCase()}/logs`
        );

        const docs = await getDocs(query(colRef, limit(50), orderBy('timestamp', 'desc')));
        const docsData = docs?.docs.map((doc) => {
          return {
            ...doc.data(),
            app: doc.ref.path.split('/')[5].toUpperCase(),
          };
        }) as PushNotificationLog[];

        const uniqDocs = docsData?.filter(
          (doc, index, self) =>
            index === self.findIndex((t) => t?.data?.apnsCollapseKey === doc?.data?.apnsCollapseKey)
        );

        setNotificationDocs(uniqDocs);
      };
      getNotificationDocs();
    }
  }, [selectedAbbrv, selectedType]);

  const rowsSent = notificationDocs?.map((data: PushNotificationLog) =>
    convertFirestoreLogToDatagridFormat(data)
  );

  const onSelectedType = (selectedType: PushNotificationType) => {
    setSelectedType(selectedType);
  };

  return (
    <>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4} maxWidth={500} minHeight={40}>
        <SelectType onSelectedType={onSelectedType} />
      </Stack>
      <Paper elevation={2} sx={styles.container}>
        <DataGrid
          sx={styles.dataGrid}
          rowHeight={40}
          rows={rowsSent || []}
          columns={columns}
          autoPageSize
          disableRowSelectionOnClick
          disableColumnFilter
          disableColumnMenu
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: 'timestamp',
                  sort: 'desc',
                },
              ],
            },
          }}
        />
      </Paper>
    </>
  );
};

export default PushNoticationAutomated;
